import { ExclamationCircleIcon, EyeSlashIcon, PencilIcon, ShareIcon, TrashIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { COPY } from '../../../../assets/strings';
import { useAppSelector } from '../../../../redux/app/hooks';
import { RootState } from '../../../../redux/app/store';
import { FeatureKeys } from '../../../../redux/features/app/AppState';

interface IListItemActionsProps {
    chatId: string;
    isHidden: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onEditTitleClick: (e: any) => void;
    onHideChatClick: () => void;
    onRestoreChatClick: () => void;
    onDeleteChatClick: () => void;
    onShareChatClick: () => void;
}

export const ListItemActions: React.FC<IListItemActionsProps> = ({
    chatId,
    isHidden,
    onEditTitleClick,
    onHideChatClick,
    onRestoreChatClick,
    onDeleteChatClick,
    onShareChatClick,
}) => {
    const { features } = useAppSelector((state: RootState) => state.app);
    const { conversations } = useAppSelector((state: RootState) => state.conversations);

    return (
        <div className="contents">
            {conversations[chatId].disabled ? (
                <button
                    disabled
                    title={COPY.CHAT_DELETED_MESSAGE()}
                    className="flex w-full items-center rounded-lg p-2 transition opacity-50 dark:text-slate-200">
                    <ExclamationCircleIcon className="mr-4 h-5 w-5" />
                    Deleted chat
                </button>
            ) : (
                <>
                    <button
                        className="flex w-full items-center rounded-lg p-2 transition hover:bg-slate-200 dark:hover:bg-slate-600 dark:text-slate-200"
                        onClick={onEditTitleClick}>
                        <PencilIcon className="mr-4 h-5 w-5" />
                        Edit
                    </button>
                    {features[FeatureKeys.MultiUserChat].enabled && 
                        conversations[chatId].isSaved &&
                    (
                        <button
                            className="flex w-full items-center rounded-lg p-2 transition hover:bg-slate-200 dark:hover:bg-slate-600 dark:text-slate-200"
                            onClick={(e) => {
                                e.stopPropagation();
                                onShareChatClick();
                            }}>
                            <ShareIcon className="mr-4 h-5 w-5" />
                            Share
                        </button>
                    )}
                    {features[FeatureKeys.HiddenChats].enabled &&
                        (!isHidden ? (
                            <button
                                className="flex w-full items-center rounded-lg p-2 transition hover:bg-slate-200 dark:hover:bg-slate-600 dark:text-slate-200"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onHideChatClick();
                                }}>
                                <EyeSlashIcon className="mr-4 h-5 w-5" />
                                Hide
                            </button>
                        ) : (
                            <button
                                className="flex items-center rounded-lg p-2 transition hover:bg-slate-200 dark:hover:bg-slate-600 dark:text-slate-200"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onRestoreChatClick();
                                }}>
                                <EyeSlashIcon className="mr-4 h-5 w-5" />
                                Restore
                            </button>
                        ))}
                    {features[FeatureKeys.DeleteChat].enabled && (
                        <button
                            className="flex items-center rounded-lg p-2 transition hover:bg-slate-200 dark:hover:bg-slate-600 dark:text-slate-200"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDeleteChatClick();
                            }}>
                            <TrashIcon className="mr-4 h-5 w-5" />
                            Delete
                        </button>
                    )}
                </>
            )}
        </div>
    );
};
